<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UXNwj7/tc-custom/9780802195784.jpg?1726755912898" alt="This image is the cover for the book Cockpit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cockpit
      </h1>
      <p class="bookDescription body article font2">
        <b>From the acclaimed author of <i>Being There</i> and <i>The Painted Bird</i>, this “dazzling succession of . . . erotic anecdotes . . . brilliantly def[ies] the limitations of its form” (<i>The New York Times Book Review</i>).</b><br/>  <br/> An agent known only as Tarden is a former operative of the mysterious security agency “the Service.” He has erased himself from all dossiers and transcripts. Now a fugitive, he moves across the landscape free of identity, in search of adventure and intrigue. But Tarden is a man of many disguises, and he is alternately avenger and savior, judge and trickster, as he enters the lives of others, forcing them into the arena of his judgment. In <i>Cockpit</i>, Kosinski is at his most startling and powerful, stripping away pretension and illusions of security to reveal the source of real strength within.<br/>  <br/> “Jerzy Kosinki’s work glistens with social observation and psychological apprehension. Not since Conrad has an Eastern European found so profound a voice in the English language.” —<i>Time</i><br/>  <br/> “A vicious peepshow-parable about a world we reluctantly recognize now and then.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerzy Kosinski
      </h2>
      
      <p class="authorDescription body article">Jerzy Kosinski (1933&ndash;1991) won the Academy of Arts and Letters Award in Literature (1970), National Book Award for <I>Steps&#160;</I>(1969), best Screenplay of the Year Award for &quot;Being There&quot; from the Writers Guild of America (1980) as well as the British Academy of Film and Television Arts (BAFTA; 1981). In 1967, he was a Guggenheim fellow. This just names a few of his many achievements.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press New York
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46bf9c06